module.exports = __webpack_public_path__ + "static/media/skyscout-monocular-4.2d876b9c.jpg";